import ClusterColumnChart from 'apollo-react/components/ClusterColumnChart';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import ReactResizeDetector from 'react-resize-detector';

import { useTranslation } from '../../../custom-hooks/useTranslation';
import { useWindowDimensions } from '../../../custom-hooks/useWindowDimensions';
import { getUITA, isTrue } from '../../../utils/commonUtils';
import Accordion from '../../components/Accordion';

const SSRuntimeClusterColumnChart = ({
  id,
  title,
  header,
  evaluatedData,
  width,
  height,
  yTicks,
  suffix,
}) => {
  const translateString = useTranslation();
  const { isMobileDevice } = useWindowDimensions();

  const [isCollapsed, setCollapsed] = useState(isMobileDevice);
  const [remount, setRemount] = useState(false);

  useEffect(() => {
    // ClusterColumnChart is not responsive
    // we need to remount it every time its size is changed
    remount && setRemount(false);
  }, [remount]);

  return (
    <>
      <div ui-ta={getUITA('FormPart', 'SSClusterColumnChart')} data-ss-id={id}>
        <Accordion
          isCollapsed={isCollapsed}
          showHeader={isTrue(header) && !_.isNil(title)}
          title={title}
          autoScrollUpEnabled={isMobileDevice && isCollapsed}
          onChange={() => setCollapsed(!isCollapsed)}
        >
          {evaluatedData && !remount ? (
            <ClusterColumnChart
              data={evaluatedData}
              width={width}
              height={height}
              yTicks={yTicks}
              suffix={suffix}
            />
          ) : (
            translateString('Cluster Column Chart: No data specified')
          )}
        </Accordion>
      </div>
      <ReactResizeDetector handleWidth onResize={() => setRemount(true)} />
    </>
  );
};

export default SSRuntimeClusterColumnChart;
